import Template41Svelte from './Template41.svelte';

export default class Template41AnswerSummary extends BaseView {

    initialize({
        model,
        response,
    }) {
        this.addSvelteChildView(
            this.$el,
            Template41Svelte,
            {
                model,
                response,
                taskContainerElement: this.el,
                isAnswerSummary: true,
            },
        )
    }
}
